import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-gestion',
  templateUrl: './edit-gestion.component.html',
  styleUrls: ['./edit-gestion.component.scss']
})
export class EditGestionComponent implements OnInit {

  form !: FormGroup;
  keys: string[] = [];
  inputs: string[] = [];
  names: Array<any> = [];
  id !: number;

  constructor(public dialogRef: MatDialogRef<any>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private builder: FormBuilder) { }

  ngOnInit(): void {

    if (this.data.form) {

      this.id = this.data.id;

      Object.keys(this.data.form.controls).forEach((el) => {
        this.keys.push(el);
      })


      this.data.inputs.forEach((element: any) => {
        this.inputs.push(element);
      });

      for (let i = 0; i < this.keys.length; i++) {
        this.names.push({ message: this.inputs[i], control: this.keys[i] });
      }

      this.form = this.builder.group({});

      let formControlFields = [];

      for (let i = 0; i < this.data.value.length; i++) {
        formControlFields.push({ name: this.keys[i], control: new FormControl('', Validators.required) })
      }

      formControlFields.forEach(f => this.form.addControl(f.name, f.control));

      for (let i = 0; i < formControlFields.length; i++) {
        for (let i = 0; i < this.data.value.length; i++) {
          formControlFields[i].control.setValue(this.data.value[i]);
        }
      }
    }

  }


  onSubmit() {
    this.dialogRef.close({ id: this.id, values: Object.values(this.form.value) });
  }

}
